import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  Modal,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import boxStyles from '../../styles/boxStyles';
import LoadingSpinner from '../../components/LoadingSpinner';
import { useAuth } from 'oidc-react';
import { useNavigate } from 'react-router-dom';
import { Pie } from 'react-chartjs-2';
import ApiService from '../../services/ApiService';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DataTable from './Detail/ActionItemsTable';
import DataTableCreator from './Detail/ActionItemsCreatorTable';
import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material/styles';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';
import ExcelIcon from '../../components/Icon/ExcelIcon';

const options = {
  plugins: {
    tooltip: {
      callbacks: {
        label: (context) => {
          const label = context.label || '';
          const value = context.parsed || 0;
          const total = context.dataset.data.reduce((a, b) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(2);
          return `${label}: ${percentage}%`;
        },
      },
    },
    datalabels: {
      formatter: function (value) {
        return value;
      },
      font: {
        weight: 'bold',
        size: '20px',
      },
    },
    legend: {
      position: 'bottom',
      title: { display: true, padding: 12 }, // or whatever number
      labels: {
        boxWidth: 12,
        font: {
          size: 14,
          weight: 600,
        },
      },
      onClick: null,
    },
  },
};

const chartPlugins = {
  id: 'legendMargin',
  beforeInit: function (chart) {
    const fitValue = chart.legend.fit;

    chart.legend.fit = function fit() {
      fitValue.bind(chart.legend)();
      return (this.height += 25);
    };
  },
};

const dataRole = [
  { name: 'All' },
  { name: 'Creator' },
  { name: 'PIC' },
  { name: 'Reviewer' },
  { name: 'Approval' },
];

const priorityActionTracking = [
  { id: 1, name: 'Low' },
  { id: 2, name: 'Medium' },
  { id: 3, name: 'High' },
];

const ActionTracking = () => {
  const { userData } = useAuth();
  const [permissions, setPermissions] = useState([]);
  const history = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingStatusChart, setIsLoadingStatusChart] = useState(true);
  const [isLoadingPriorityChart, setIsLoadingPriorityChart] = useState(true);
  const [paginationPayloadpagination, setPagination] = useState('');
  const [kegiatanActionTracking, setKegiatanActionTracking] = useState([]);
  const [tahunActionTrackinng, setTahunActionTracking] = useState([]);
  const [statusHeaderActionTracking, setStatusHeaderActionTracking] = useState(
    []
  );
  const [fungsiActionTracking, setFungsiActionTracking] = useState([]);
  const [dataRegion, setDataRegion] = useState([]);
  const [regionId, setRegionId] = useState(0);
  const [lokasiId, setLokasiId] = useState(0);
  const [yearId, setYearId] = useState(0);
  const [priorityId, setPriorityId] = useState(0);
  const [kegiatanId, setKegiatanId] = useState(0);
  const [fungsiId, setFungsiId] = useState(0);
  const [status, setStatus] = useState('');

  const [dataLokasi, setDataLokasi] = useState([]);
  const [dataTaskList, setDataTaskList] = useState([]);
  const [dataTaskListCreator, setDataTaskListCreator] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [openReassignModal, setOpenReassignModal] = useState(false);
  const [reAssignRow, setReAssignRow] = useState(null);
  const childRef = useRef(null);

  const [taskListAuthorization, setTaskListAuthorization] = useState({
    aC_EXPORT_DATA: false,
    aC_CREATE_ACTION_TRACKING: false,
  });

  const [taskListCreatorAuthorization, setTaskListCreatorAuthorization] =
    useState({
      aC_EXPORT_DATA: false,
      aC_CREATE_ACTION_TRACKING: false,
    });

  const [statusChartData, setStatusChartData] = useState({
    labels: ['Open', 'In Progress', 'Over Due', 'Closed'],
    datasets: [
      {
        label: '# of Votes',
        data: [12, 19, 3],
        backgroundColor: ['#ff9100', '#FFFF00', '#FF0000', '#98FB98'],
      },
    ],
  });

  const [prioritasChartData, setPrioritasChartData] = useState({
    labels: ['Low', 'Medium', 'High'],
    datasets: [
      {
        label: '# of Votes',
        data: [12, 19, 3],
        backgroundColor: ['#FFFF00', '#A8D18D', '#BE0000'],
      },
    ],
  });

  // useEffect(() => {
  //   let checkRole = localStorage.getItem('roleName');
  //   if (checkRole) {
  //     if (checkRole.replaceAll('"', '') == 'USER_HIMS') {
  //       console.log('test');
  //       history('/hsse');
  //     }
  //   }
  // }, []);

  const exportToXLSX = (data) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    const excelData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(excelData, 'grid_data.xlsx');
  };

  const getDataRegion = () => {
    ApiService.getMsRegional().then((res) => {
      var result = res.data.payload;
      setDataRegion(result);
    });
  };

  const getDataLokasi = () => {
    if (!regionId) return;
    ApiService.getMsLokasi(regionId).then((res) => {
      var result = res.data.payload;
      setDataLokasi(result);
    });
  };

  const getActionTrackingTask = () => {
    ApiService.getActionTrackingTaskList({
      page: 1,
      itemPerPage: 1,
      role: '',
    })
      .then(({ data }) => {
        if (data && data.payload) {
          setDataTaskList([...data.payload.data]);
          setTaskListAuthorization(data.payload.authorizeAction);
          setPagination(data.payload.pagination);
        } else {
          console.error('Error: Payload is null');
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching action tracking task list:', error);
        setIsLoading(false);
      });
  };

  const getActionTrackingTaskCreator = () => {
    ApiService.getActionTrackingTaskListCreator({
      page: 1,
      itemPerPage: 10,
      role: 'creator',
    })
      .then(({ data }) => {
        if (data && data.payload) {
          setDataTaskListCreator([...data.payload.data]);
          setTaskListCreatorAuthorization(data.payload.authorizeAction);
          setPagination(data.payload.pagination);
        } else {
          console.error('Error: Payload is null');
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          'Error fetching action tracking task list for creator:',
          error
        );
        setIsLoading(false);
      });
  };

  const getKegiatanActionTracking = () => {
    ApiService.getKegiatanActionTracking()
      .then(({ data }) => {
        setKegiatanActionTracking([...data.payload]);
      })
      .catch((error) => {
        console.error('Error fetching Kegiatan Action Tracking:', error);
        setKegiatanActionTracking([]); // Default value in case of error
      });
  };

  const getTahunActionTracking = () => {
    ApiService.getTahunActionTracking()
      .then(({ data }) => {
        setTahunActionTracking([...data.payload]);
      })
      .catch((error) => {
        console.error('Error fetching Tahun Action Tracking:', error);
        setTahunActionTracking([]); // Default value
      });
  };

  const getStatusHeaderActionTracking = () => {
    ApiService.getStatusHeaderActionTracking()
      .then(({ data }) => {
        setStatusHeaderActionTracking([...data.payload]);
      })
      .catch((error) => {
        console.error('Error fetching Status Header Action Tracking:', error);
        setStatusHeaderActionTracking([]); // Default value
      });
  };

  const getFungsiActionTracking = () => {
    ApiService.getFungsiActionTracking()
      .then(({ data }) => {
        setFungsiActionTracking([...data.payload]);
      })
      .catch((error) => {
        console.error('Error fetching Fungsi Action Tracking:', error);
        setFungsiActionTracking([]); // Default value
      });
  };

  const getChart = () => {
    ApiService.getChartByPriority({
      regionId: regionId,
      locationId: lokasiId,
      year: yearId,
      priority: priorityId,
      kegiatanId: kegiatanId,
      status: status,
      fungsiId: fungsiId,
    })
      .then(({ data }) => {
        if (data.payload) {
          const colors = ['#369120', '#FFFF00', '#BE0000'];
          const colorLookup = {
            Low: colors[0],
            Medium: colors[1],
            High: colors[2],
          };

          setPrioritasChartData({
            ...prioritasChartData,
            labels: data.payload.map((item) => item.groupName),
            datasets: [
              {
                label: '# of Votes',
                data: data.payload.map((item) => item.countData),
                backgroundColor: data.payload.map(
                  (item) => colorLookup[item.groupName] || ''
                ),
              },
            ],
          });
        } else {
          setPrioritasChartData({
            labels: [],
            datasets: [
              {
                label: '# of Votes',
                data: [],
                backgroundColor: [],
              },
            ],
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching Chart by Priority:', error);
        setIsLoadingPriorityChart(false);
      })
      .finally(() => {
        setIsLoadingPriorityChart(false);
      });

    ApiService.getChartByStatus({
      regionId: regionId,
      locationId: lokasiId,
      year: yearId,
      priority: priorityId,
      kegiatanId: kegiatanId,
      status: status,
      fungsiId: fungsiId,
    })
      .then(({ data }) => {
        if (data.payload) {
          const colors = ['#ff9100', '#FFFF00', '#FF0000', '#98FB98'];
          const colorLookup = {
            Open: colors[0],
            'In Progress': colors[1],
            'Over Due': colors[2],
            Closed: colors[3],
          };

          setStatusChartData({
            ...statusChartData,
            labels: data.payload.map((item) => item.groupName),
            datasets: [
              {
                label: '# of Votes',
                data: data.payload.map((item) => item.countData),
                backgroundColor: data.payload.map(
                  (item) => colorLookup[item.groupName] || ''
                ),
              },
            ],
          });
        } else {
          setStatusChartData({
            labels: [],
            datasets: [
              {
                label: '# of Votes',
                data: [],
                backgroundColor: [],
              },
            ],
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching Chart by Status:', error);
        setIsLoadingStatusChart(false);
      })
      .finally(() => {
        setIsLoadingStatusChart(false);
      });
  };

  const handleExport = (args = {}) => {
    const payload = {
      role: '',
      regionId: 0,
      locationId: 0,
      kegiatan: 0,
      year: 0,
      priority: 0,
      status: '',
      fungsiId: 0,
      emailLogin: userData?.profile?.email,
      IsHeader: true,
      ...args,
    };

    setIsDownloading(true);
    ApiService.exportExcelActionTracking(payload)
      .then(({ data }) => {
        return data.payload || [];
      })
      .then((data) => {
        const convertedData = data.map((obj) => {
          const convertedObj = {};

          for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
              const titleCaseKey = key
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, (str) => str.toUpperCase());
              convertedObj[titleCaseKey] = obj[key];
            }
          }

          return convertedObj;
        });
        exportToXLSX(convertedData);
        if (data) {
          setSnackbarMessage('Report file exported successfully');
        }
      })
      .catch((e) => {
        setSnackbarMessage(e.message);
      })
      .finally(() => {
        setIsDownloading(false);
        setSnackbarOpen(true);
      });
  };

  const handleNewAssignedCreator = ({ success, data }) => {
    if (!success) {
      setSnackbarMessage('Creator reassigned failed');
      setSnackbarOpen(true);
      setOpenReassignModal(false);
      return;
    }
    childRef.current.updateRow(data);
    setSnackbarMessage('Creator reassigned successfully');
    setSnackbarOpen(true);
    setOpenReassignModal(false);
  };

  const handleReAssignCreator = (row) => {
    setReAssignRow(row);
    setOpenReassignModal(true);
  };

  useEffect(() => {
    getDataRegion();
    getActionTrackingTask();
    getActionTrackingTaskCreator();
    getKegiatanActionTracking();
    getTahunActionTracking();
    getStatusHeaderActionTracking();
    getFungsiActionTracking();
    getChart();
  }, []);

  useEffect(() => {
    getDataLokasi();
  }, [regionId]);

  useEffect(() => {
    getChart();
  }, [regionId, lokasiId, yearId, priorityId, kegiatanId, status, fungsiId]);

  const onChangeRegion = (event, value) => {
    if (!value) {
      setRegionId(0);
      setDataLokasi([]);
      return;
    }
    setRegionId(value.id);
  };

  const onChangeLokasi = (event, value) => {
    if (!value) {
      setLokasiId(0);
      return;
    }
    setLokasiId(value.id);
  };

  const onYearChange = (event, value) => {
    if (!value) {
      setYearId(0);
      return;
    }
    setYearId(value.id);
  };
  const onPriorityChange = (event, value) => {
    if (!value) {
      setPriorityId(0);
      return;
    }
    setPriorityId(value.id);
  };
  const onFungsiChange = (event, value) => {
    if (!value) {
      setFungsiId(0);
      return;
    }
    setFungsiId(value.id);
  };

  const onKegiatanChange = (event, value) => {
    if (!value) {
      setKegiatanId(0);
      return;
    }
    setKegiatanId(value.id);
  };

  const onStatusChange = (event, value) => {
    if (!value) {
      setStatus('');
      return;
    }
    setStatus(value.name);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const StyledFormControl = styled(FormControl)`
    width: 100%;
    margin: 0;
    margin-right: 8px;
  `;

  const StyledForm = styled('form')(({ theme }) => ({
    '& .MuiTextField-root': {
      margin: `${theme.spacing(1)}px 0 ${theme.spacing(1)}px 8px`,
    },
  }));

  const StyledTextField = styled(TextField)`
    textarea {
      width: 100%;
      resize: both;
    }
  `;

  const MemoTextArea = memo(({ handleChange }) => (
    <StyledFormControl>
      <StyledForm noValidate autoComplete="off">
        <div>
          <StyledTextField
            id="outlined-textarea"
            label="Remark"
            placeholder="Placeholder"
            multiline
            variant="outlined"
            onChange={handleChange}
            sx={{ width: '100%' }}
          />
        </div>
      </StyledForm>
    </StyledFormControl>
  ));

  const ReAssignModal = memo(
    ({
      isOpen = false,
      reAssignRow = null,
      onAssignedNewCreator,
      setModalOpen,
    }) => {
      const [users, setUsers] = useState([]);
      const [isLoadingUsers, setIsLoadingUsers] = useState(true);
      const [remark, setRemark] = useState('');

      const [payload, setPayload] = useState({
        emailCreator: '',
        remark: '',
        actionTrackingId: reAssignRow?.idActionTracking,
      });

      const getUsers = async (val) => {
        try {
          await ApiService.getListUserAdmin(val).then((res) => {
            if (res.data.isOk) {
              setUsers(res.data.payload);
            } else {
              setTimeout(() => {
                // router("/");
              }, 500);
            }
          });
        } catch (error) {
          alert('The Error was occured', error);
          setTimeout(() => {
            // router("/");
          }, 500);
        }
      };
      const handleKeyDown = async (e) => {
        if ((e.key == 'Enter' || e.key == ' ') && e.target.value.length >= 5) {
          setIsLoadingUsers(true);
          await getUsers(e.target.value);
          setIsLoadingUsers(false);
        }
      };

      const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '40%',
        margin: '2% 0',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 3,
      };

      const handleClose = () => {
        setModalOpen(false);
      };

      const handleRemarkChange = useCallback((event) => {
        setRemark(event.target.value);
      }, []);

      const handleCreatorChange = (e, value) => {
        if (!value) {
          setPayload({ ...payload, emailCreator: '' });
          return;
        }
        setPayload({ ...payload, emailCreator: value.email });
      };

      return (
        <Modal open={isOpen} onClose={handleClose}>
          <Box component="div" sx={modalStyle}>
            <Grid container>
              <Grid item xs={12} sx={{ marginBottom: 3 }}>
                <h2>Re-Assign Creator</h2>
              </Grid>
              <Grid item xs={12} marginBottom={2}>
                <FormControl fullWidth>
                  <TextField
                    label="Action Tracking"
                    value={reAssignRow?.nomorActionTracking}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} marginBottom={2}>
                <FormControl fullWidth>
                  <TextField
                    label="Judul"
                    value={reAssignRow?.judul}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} marginBottom={2}>
                <FormControl fullWidth>
                  <TextField
                    label="Kegiatan"
                    value={reAssignRow?.namaKegiatan}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} marginBottom={2}>
                <FormControl fullWidth>
                  <TextField
                    label="Regional"
                    value={reAssignRow?.namaRegional}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} marginBottom={2}>
                <FormControl fullWidth>
                  <TextField
                    label="Lokasi"
                    value={reAssignRow?.namaLokasi}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} marginBottom={2}>
                <FormControl fullWidth>
                  <Autocomplete
                    loading={isLoadingUsers}
                    name="creatorEmail"
                    onChange={handleCreatorChange}
                    onKeyDown={handleKeyDown}
                    required
                    getOptionLabel={(option) =>
                      `${option.namalengkap} - ${option.jabatan}`
                    }
                    options={users}
                    renderInput={(params) => (
                      <TextField {...params} label="Creator" />
                    )}
                    getOptionSelected={(option, value) =>
                      option.namalengkap === value.namalengkap
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ marginBottom: 3 }}>
                <MemoTextArea handleChange={handleRemarkChange} />
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ marginBottom: 3 }}
                container
                justifyContent="flex-end"
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    const reqBody = { ...payload, remark: remark };
                    ApiService.reAssignCreator(reqBody)
                      .then(({ data }) => {
                        if (data.isOk) {
                          onAssignedNewCreator({
                            success: true,
                            data: reqBody,
                          });
                        } else {
                          onAssignedNewCreator({
                            success: false,
                            data: reqBody,
                          });
                        }
                      })
                      .catch((e) => {
                        console.log(e);
                        onAssignedNewCreator({ success: false, data: reqBody });
                      })
                      .finally(() => handleClose());
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      );
    }
  );

  const actionTrackingChart = (
    <>
      <Grid container spacing={2} marginBottom={2}>
        <Grid item xs={8} container>
          <Grid item xs={12}>
            <Typography variant="h5" marginTop={3}>
              HSSE Action Tracking Dashboard
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            justifyContent="center"
            alignItems="center"
            marginTop={3}
          >
            <Typography
              textAlign={'center'}
              variant="subtitle1"
              marginBottom={4}
              sx={{ fontWeight: 'bold' }}
            >
              Status
            </Typography>
            <Pie
              data={statusChartData}
              options={options}
              plugins={[chartPlugins]}
              width={120}
              height={120}
            />
          </Grid>
          <Grid
            item
            xs={6}
            justifyContent="center"
            alignItems="center"
            marginTop={3}
          >
            <Typography
              textAlign={'center'}
              variant="subtitle1"
              marginBottom={4}
              sx={{ fontWeight: 'bold' }}
            >
              Prioritas
            </Typography>
            <Pie
              data={prioritasChartData}
              options={options}
              plugins={[chartPlugins]}
              width={120}
              height={120}
            />
          </Grid>
        </Grid>
        <Grid
          item
          xs={4}
          container
          spacing={2}
          style={{ paddingTop: '60px', paddingBottom: '60px' }}
        >
          <Grid item xs={12} container justifyContent="flex-end">
            {taskListAuthorization.aC_EXPORT_DATA && (
              <LoadingButton
                variant="outlined"
                color="primary"
                startIcon={<FileDownloadIcon />}
                loading={isDownloading}
                onClick={() =>
                  handleExport({
                    year: yearId,
                    priority: priorityId,
                    status: status,
                    regionId: regionId,
                    locationId: lokasiId,
                    kegiatan: kegiatanId,
                    fungsiId: fungsiId,
                    role: 'all',
                    IsHeader: false,
                  })
                }
              >
                Export Data
              </LoadingButton>
            )}
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Autocomplete
                name="idRegional"
                onChange={onChangeRegion}
                required
                getOptionLabel={(option) => option.name}
                options={dataRegion}
                renderInput={(params) => (
                  <TextField {...params} label="Regional" />
                )}
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Autocomplete
                name="idLokasi"
                onChange={onChangeLokasi}
                required
                getOptionLabel={(option) => option.name}
                options={dataLokasi}
                renderInput={(params) => (
                  <TextField {...params} label="Lokasi" />
                )}
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Autocomplete
                name="kegiatan"
                onChange={onKegiatanChange}
                required
                getOptionLabel={(option) => option.name}
                options={kegiatanActionTracking}
                renderInput={(params) => (
                  <TextField {...params} label="Kegiatan" />
                )}
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Autocomplete
                name="tahun"
                required
                onChange={onYearChange}
                getOptionLabel={(option) => option.name}
                options={tahunActionTrackinng}
                renderInput={(params) => (
                  <TextField {...params} label="Tahun" />
                )}
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Autocomplete
                name="status"
                required
                onChange={onStatusChange}
                getOptionLabel={(option) => option.name}
                options={statusHeaderActionTracking}
                renderInput={(params) => (
                  <TextField {...params} label="Status" />
                )}
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Autocomplete
                name="prioritas"
                required
                onChange={onPriorityChange}
                getOptionLabel={(option) => option.name}
                options={priorityActionTracking}
                renderInput={(params) => (
                  <TextField {...params} label="Prioritas" />
                )}
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Autocomplete
                name="fungsi"
                required
                onChange={onFungsiChange}
                getOptionLabel={(option) => option.name}
                options={fungsiActionTracking}
                renderInput={(params) => (
                  <TextField {...params} label="Fungsi" />
                )}
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
              />
            </FormControl>
          </Grid>
        </Grid>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          message={snackbarMessage}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        />
      </Grid>
    </>
  );

  const taskListTable = (
    <>
      <Grid container spacing={2} marginBottom={3} alignItems="center">
        <Grid item xs={10}>
          <Typography variant="h5" marginTop={3}>
            Task List
          </Typography>
        </Grid>
        <Grid
          item
          xs={2}
          justifyContent="center"
          alignItems="center"
          container
          marginTop={3}
        >
          <LoadingButton
            variant="text"
            color="primary"
            startIcon={<ExcelIcon />}
            loading={isDownloading}
            onClick={() => {
              const paginationPayload = childRef.current.getPaginationPayload();
              handleExport(paginationPayload);
            }}
          >
            Download
          </LoadingButton>
        </Grid>
      </Grid>
      <Grid item spacing={2} container>
        <Grid item xs={12}>
          <DataTable
            ref={childRef}
            taskListAuthorization={taskListAuthorization}
            stateRegion={[dataRegion, setDataRegion]}
            stateLokasi={[dataLokasi, setDataLokasi]}
            stateKegiatan={[kegiatanActionTracking, setKegiatanActionTracking]}
            dataRole={dataRole}
            download={handleExport}
            onReAssignCreator={handleReAssignCreator}
            onUnauthorized={(message) => {
              setSnackbarMessage(message);
              setSnackbarOpen(true);
            }}
          />
        </Grid>
      </Grid>
    </>
  );

  const creatorTable = (
    <>
      <Grid item spacing={2} container>
        <DataTableCreator
          taskListAuthorization={taskListCreatorAuthorization}
          stateRegion={[dataRegion, setDataRegion]}
          stateLokasi={[dataLokasi, setDataLokasi]}
          stateKegiatan={[kegiatanActionTracking, setKegiatanActionTracking]}
          dataRole={dataRole}
          download={handleExport}
          isDownloading={isDownloading}
        />
      </Grid>
    </>
  );

  return (
    <Container maxWidth>
      <p>Login as {userData?.profile?.display_name}</p>
      <h1>HSSE Action Tracking</h1>
      <Box component="div" sx={boxStyles} id="tabel">
        {isLoading ? <LoadingSpinner /> : actionTrackingChart}
      </Box>

      <Box
        component="div"
        sx={{ ...boxStyles }}
        id="tabel2"
        style={{ marginTop: '50px' }}
      >
        {isLoading ? <LoadingSpinner /> : taskListTable}
      </Box>

      <Box
        component="div"
        sx={boxStyles}
        id="tabel2"
        style={{ marginTop: '50px' }}
      >
        {isLoading ? <LoadingSpinner /> : creatorTable}
      </Box>

      {openReassignModal && (
        <ReAssignModal
          isOpen={openReassignModal}
          setModalOpen={setOpenReassignModal}
          reAssignRow={reAssignRow}
          onAssignedNewCreator={handleNewAssignedCreator}
        />
      )}
    </Container>
  );
};

export default ActionTracking;
